import * as THREE from 'three';

export default class BasicObject extends THREE.Mesh {
  constructor() {
    super();
  }
  buildGeometry() {
    if (this.geometry) {
      this.geometry.dispose();
      // this.geometry = null;
    }
  }
  hoverOn() {
    // console.log('realisation')
  }
  hoverOff() {
    // console.log('realisation')
  }
  dragStart() {
    // console.log('realisation')
  }
  drag() {
    // console.log('realisation')
  }
  dragEnd() {
    // console.log('realisation')
  }
  removeMesh(mesh: THREE.Mesh) {
    mesh.geometry.dispose();
    // mesh.geometry = null;
    if (mesh.material instanceof Array) {
      mesh.material.forEach(material => {
        if (material && material instanceof THREE.MeshBasicMaterial && material?.map) {
          material.map.dispose();
          material.map = null;
          material.dispose();
        }
        // material = null;
      });
    }
    //-----
    else {
      if (mesh.material && mesh.material instanceof THREE.MeshBasicMaterial && mesh.material?.map) {
        mesh.material.map.dispose();
        mesh.material.map = null;
        mesh.material.dispose();
      }
    }
    // mesh.material = null;
    mesh?.parent?.remove(mesh);
    // console.log('realisation')
  }
}
